// import { formatStr } from '@/utils/utils';
import { Modal, Table, Tooltip, Spin, message } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  getComponentVersions,
  getComponentDownUrl,
  updateComponentVersion,
  exportFileApi,
} from '@/services/source';
import { isDownloadable } from '@/services/element';
import { downLoadFile } from '@/utils/utils';
import styles from './index.module.less';
import { useSetRecoilState } from 'recoil';
import { exportModalVisibleStore } from '@/store';

interface CardInfoProps {
  data?: ELEMENT.Component;
  view: Function;
  visible: boolean;
  onCancel: () => void;
  init: () => void;
}

export default React.memo((props: CardInfoProps) => {
  const { data, view, visible, onCancel, init } = props;
  const [versions, setVersions] = useState<ELEMENT.VersionItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  //导出
  const setExportModalVisble = useSetRecoilState(exportModalVisibleStore);

  const handleModal = async () => {
    const res = await getComponentVersions(data!.id);
    setIsLoading(false);
    if (res?.success) {
      setVersions(res?.data?.details || []);
    }
  };

  const handleSetCurrentVersion = async (item: any) => {
    const res = await updateComponentVersion({
      componentId: item?.componentId,
      versionId: item?.id,
    });
    if (res?.success) {
      handleModal();
      init();
    }
  };

  useEffect(() => {
    handleModal();
  }, []);

  const downLoadFileFn = async (row: any) => {
    const res = await getComponentDownUrl(row?.sourceFileId || '', row?.sourceFileName?.split('.')[0] || '构件');
    if (res?.data?.details?.downloadUrl) {
      downLoadFile(res?.data?.details?.downloadUrl, row?.name || '构件');
    }
  };

  const exportFn = async (ids: string[]) => {
    const res = await exportFileApi(ids);
    if (res?.success) {
      message.loading({
        content: (
          <span className="report">
            文件准备中，请稍候。导出完成后，请前往
            <span
              className="report2"
              onClick={() => {
                message.destroy();
                setExportModalVisble(true);
              }}
            >
              个人中心-导出任务
            </span>
            手动下载
          </span>
        ),
      });
    }
  };

  const handleDownLoad = async (item?: ELEMENT.Component) => {
    if (item?.downloadable) {
      downLoadFileFn(item);
    } else {
      if (item?.id) {
        const res = await isDownloadable([item.id]);
        if (res?.data?.details?.allDownloadable) {
          downLoadFileFn(item);
        } else {
          if (item?.id) {
            exportFn([item.id]);
          }
        }
      }
    }
  };

  const columns = [
    {
      title: '文件名称',
      dataIndex: 'sourceFileName',
      key: 'sourceFileName',
      render: (_text: any, row: any) => {
        return (
          <div className="flex-ai-center">
            <Tooltip title={_text}>
              <span className="ellipsis_txt" style={{ maxWidth: row?.master ? '140px' : '200px' }}>
                {/* {row?.master ? formatStr(_text || '', 10) : formatStr(_text || '', 15)} */}
                {_text}
              </span>
            </Tooltip>
            {row?.master && <span className={styles.tag}>当前版本</span>}
          </div>
        );
      },
    },
    {
      title: '上传人',
      dataIndex: 'createdBy',
      key: 'createdBy',
      width: 80,
    },
    {
      title: '上传日期',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (val: string) => {
        return moment(val).format('YYYY.M.D');
      },
    },
    {
      title: '版本号',
      dataIndex: 'version',
      key: 'version',
      width: 80,
      render: (val: string) => {
        return <span className={styles.version}>{`V${val}`}</span>;
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 210,
      dataIndex: 'action',
      render: (_val: string, row: any) => {
        return (
          <div>
            <span key="view" className="table-btn" onClick={() => view(row, 'version')}>
              查看
            </span>
            <span key="download" className="table-btn" onClick={() => handleDownLoad(row)}>
              下载
            </span>
            {!row.master && (
              <span key="set" className="table-btn" onClick={() => handleSetCurrentVersion(row)}>
                设为主版本
              </span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <Modal
      title="版本管理"
      visible={visible}
      width={800}
      bodyStyle={{
        padding: '14px 18px 14px 22px',
        minHeight: '200px',
        maxHeight: '400px',
        overflowY: 'auto',
      }}
      footer={null}
      onCancel={onCancel}
      centered={true}
    >
      <div>
        {isLoading ? (
          <Spin className={styles.spin} />
        ) : (
          <Table columns={columns} dataSource={versions} pagination={false} rowKey="id" />
        )}
      </div>
    </Modal>
  );
});
